var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsHwyWide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.167,
    height: 104,
    viewBox: "0 0 118.167 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M2 10.333C2 5.73 5.407 2 9.61 2h98.945c4.204 0 7.61 3.73 7.61 8.333v83.333c0 4.603-3.406 8.333-7.61 8.333H9.61C5.408 102 2 98.27 2 93.666V10.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M59.083 3.667c-5.53 3.744-12.048 5.905-19.028 5.905s-13.497-2.16-19.027-5.905L3.522 22.833c3.222 5.013 5.113 11.125 5.113 17.72 0 4.76-.985 9.27-2.744 13.294-1.517 3.478-2.367 7.374-2.367 11.486C3.523 80.06 14.427 92 27.878 92h15.24c6.445 0 12.198 3.25 15.966 8.333C62.85 95.25 68.604 92 75.05 92h15.24c13.45 0 24.354-11.94 24.354-26.667 0-4.112-.85-8.008-2.37-11.486-1.76-4.025-2.743-8.533-2.743-13.293 0-6.596 1.892-12.708 5.114-17.72L97.14 3.666C91.61 7.41 85.09 9.572 78.11 9.572s-13.5-2.16-19.03-5.905z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsHwyWide);
export default __webpack_public_path__ + "static/media/us-hwy-wide.1ba75aa7de8d737e7840cdaef6b7a4c9.svg";
export { ForwardRef as ReactComponent };